import { useState, useRef, useEffect } from 'react';

function useAccessibilityState(args) {
    const { id, label, placeholder, errorMessage, helperText, showCounter, isEmpty, hasValue, textValue, maxLength, } = args;
    const [accessibilityKey, setAccessibilityKey] = useState(0);
    const wasEmpty = useRef(true);
    useEffect(() => {
        if (isEmpty) {
            wasEmpty.current = true;
        }
        else if (hasValue && wasEmpty.current) {
            setAccessibilityKey((k) => k + 1);
            wasEmpty.current = false;
        }
    }, [isEmpty, hasValue, textValue]);
    const areaDescribedBy = [
        isEmpty && label && `${id}-label`,
        isEmpty && placeholder && `${id}-placeholder`,
        errorMessage && `${id}-error`,
        helperText && `${id}-helper-text`,
        showCounter && `${id}-counter`,
    ]
        .filter(Boolean)
        .join(" ");
    const counterAriaLabel = isEmpty
        ? `${(textValue === null || textValue === void 0 ? void 0 : textValue.length) || 0} out of ${maxLength} characters`
        : "undefined";
    return {
        accessibilityKey,
        areaDescribedBy,
        counterAriaLabel,
    };
}

export { useAccessibilityState };
